import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Clock, LogOut } from 'lucide-react';
import { useIdleLogout } from '@/hooks/useIdleLogout';

function formatSessionLength(minutes: number): string {
  if (minutes >= 60) {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m === 0 ? `${h} time${h === 1 ? '' : 'r'}` : `${h}t ${m}m`;
  }
  return `${minutes} minutter`;
}

/**
 * Mount én gang inde i <AuthProvider>. Viser advarsel før auto-logout
 * og giver brugeren mulighed for at fortsætte arbejdet uden at miste data.
 */
export function IdleWarningDialog() {
  const { showWarning, secondsUntilLogout, stayLoggedIn, logoutNow, effectiveTimeoutMinutes } = useIdleLogout();

  const mins = Math.floor(secondsUntilLogout / 60);
  const secs = secondsUntilLogout % 60;
  const timeLabel = mins > 0 ? `${mins} min ${secs.toString().padStart(2, '0')} sek` : `${secs} sekunder`;

  return (
    <AlertDialog open={showWarning}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Clock className="w-5 h-5 text-amber-500" />
            Du logges ud om <span className="tabular-nums">{timeLabel}</span>
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-2 pt-2">
              <p>
                Tryk <strong>Fortsæt arbejde</strong> for at nulstille timeren —
                dine ændringer går ikke tabt.
              </p>
              <p className="text-xs text-muted-foreground">
                Din session varer {formatSessionLength(effectiveTimeoutMinutes)} ved inaktivitet.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={logoutNow}>
            <LogOut className="w-4 h-4 mr-1.5" />
            Log ud nu
          </Button>
          <Button onClick={stayLoggedIn}>
            Fortsæt arbejde
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
